import { useMemo } from 'react'

import { PopoverInput } from '@ui/components/Popover'

import { NameDto } from '@model/NameDto'

import { getFundingCurrencyIcon } from '@shared/components/Funding/FundingCurrencyIcons'

interface Props {
  options: NameDto<string>[]
  value?: string
  fieldName?: string
  label: string
  required?: boolean
}

export const FundingCurrencySelect: React.FC<Props> = (props) => {
  const { options, value, fieldName, label, required } = props

  const optionsWithIcons = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        startIcon: getFundingCurrencyIcon(option.id),
      })),
    [options]
  )

  if (!fieldName || options.length === 0) return null

  return (
    <PopoverInput
      showLabel
      isFullWidth
      name={fieldName}
      label={label}
      placeholder={label}
      value={value}
      options={optionsWithIcons}
      startIcon={getFundingCurrencyIcon(value)}
      selectionVariant='radio'
      hasCheckMark={false}
      required={required}
    />
  )
}
